(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDetailController', CommunicationAutomationConfDetailController);

    CommunicationAutomationConfDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationAutomationConf'];

    function CommunicationAutomationConfDetailController($scope, $rootScope, $stateParams, entity, CommunicationAutomationConf) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.load = function (id) {
            CommunicationAutomationConf.get({id: id}, function(result) {
                vm.communicationAutomationConf = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:communicationAutomationConfUpdate', function(event, result) {
            vm.communicationAutomationConf = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
